import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

export function OptionalFieldsBlock({ flags }) {
  const { t } = useTranslation();
  const { register } = useFormContext();
  if (!flags.phone_number && !flags.additional_notes && !flags.preferred_contact_method) {
    return null;
  }

  const inputClass =
    "wp:block wp:w-full wp:appearance-none wp:rounded-md wp:border wp:border-solid wp:border-gray-300 wp:[background-color:var(--wf-input-bg,#ffffff)] wp:px-4 wp:py-3 wp:text-lg wp:[color:var(--wf-text-color,#111827)] wp:shadow-sm wp:focus:border-gray-900 wp:focus:outline-none wp:focus:ring-1 wp:focus:ring-gray-900";

  return (
    <div className="wp:mb-8 wp:grid wp:gap-6">
      {flags.phone_number ? (
        <div>
          <label htmlFor="widerruf-phone" className="wp:mb-2 wp:block wp:text-base wp:font-medium">
            {t("proxy.withdrawals.optional_fields.phone")}
          </label>
          <input
            id="widerruf-phone"
            type="tel"
            {...register("customer_phone")}
            className={inputClass}
          />
        </div>
      ) : null}
      {flags.additional_notes ? (
        <div>
          <label htmlFor="widerruf-notes" className="wp:mb-2 wp:block wp:text-base wp:font-medium">
            {t("proxy.withdrawals.optional_fields.notes")}
          </label>
          <textarea
            id="widerruf-notes"
            rows={4}
            {...register("additional_notes")}
            className={`${inputClass} wp:resize-y`}
          />
        </div>
      ) : null}
      {flags.preferred_contact_method ? (
        <div>
          <label htmlFor="widerruf-contact" className="wp:mb-2 wp:block wp:text-base wp:font-medium">
            {t("proxy.withdrawals.optional_fields.preferred_contact_method")}
          </label>
          <select
            id="widerruf-contact"
            {...register("preferred_contact_method")}
            className={inputClass}
          >
            <option value="">{t("proxy.withdrawals.common.select_placeholder")}</option>
            <option value="email">{t("proxy.withdrawals.optional_fields.contact_methods.email")}</option>
            <option value="phone">{t("proxy.withdrawals.optional_fields.contact_methods.phone")}</option>
          </select>
        </div>
      ) : null}
    </div>
  );
}
